export const ADDON_ID = 'status';
